(() => {
  if (window.__tbCartFunnelInit) return;
  window.__tbCartFunnelInit = true;

  // One useful, inventory-checked suggestion; no multi-product decision carousel.
  // Halloween #2 is deliberately excluded while it has zero recorded inventory.
  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const OFFERS = {
    velvet: [
      { handle: 'royal-blue-velvet-durag', color: 'blue', label: 'Try a velvet durag in another colour' },
      { handle: 'red-velvet-durag-1', color: 'red', label: 'Try a velvet durag in another colour' },
      { handle: 'purple-velvet-durag-1', color: 'purple', label: 'Try a velvet durag in another colour' },
      { handle: 'grey-velvet-durag-1', color: 'grey', label: 'Try a velvet durag in another colour' },
      { handle: 'white-velvet-durag', color: 'white', label: 'Try a velvet durag in another colour' },
      { handle: 'black-velvet-durag-1', color: 'black', label: 'Try a velvet durag in another colour' },
      { handle: 'green-velvet-durag', color: 'green', label: 'Try a velvet durag in another colour' }
    ],
    bonnet: [
      { handle: 'beige-rose-print-silky-bonnet', color: 'beige', label: 'Another bonnet shade for your collection' },
      { handle: 'black-gold-rose-print-silky-bonnet', color: 'black', label: 'Another bonnet shade for your collection' },
      { handle: 'blue-rose-print-silky-bonnet', color: 'blue', label: 'Another bonnet shade for your collection' },
      { handle: 'yellow-rose-print-silky-bonnet', color: 'yellow', label: 'Another bonnet shade for your collection' }
    ],
    kids: [
      { handle: 'navy-blue-kids-silky-durag', color: 'blue', label: 'Another colour for the little one' },
      { handle: 'red-kids-silky-durag', color: 'red', label: 'Another colour for the little one' },
      { handle: 'white-kids-silky-durag', color: 'white', label: 'Another colour for the little one' },
      { handle: 'black-kids-silky-durag', color: 'black', label: 'Another colour for the little one' }
    ]
  };

  let renderToken = 0;
  const mounts = () => Array.from(document.querySelectorAll('[data-tb-cart-funnel]'));
  const cartText = (cart) => (cart.items || []).map(item =>
    [item.handle, item.product_title, item.title, item.product_type].filter(Boolean).join(' ').toLowerCase()
  ).join(' | ');

  const hasHandle = (cart, handle) => (cart.items || []).some(item => item.handle === handle);
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[ch]);

  const chooseCandidates = (cart) => {
    const items = cart && cart.items || [];
    if (!items.length || items.length > 2 || Number(cart.item_count || 0) > 3) return [];

    // Keep the main checkout path simple when a customer has met the threshold.
    const promo = window.TBFreeShippingProgressState;
    const summary = promo && typeof promo.getSummary === 'function' ? promo.getSummary(cart) : null;
    if (summary && summary.remaining === 0) return [];

    const text = cartText(cart);
    const jeansOnly = /\bjeans?\b/.test(text) && !/durag|bonnet|wave cap|brush|kids|mother.and.daughter|father.and.son/.test(text);
    if (jeansOnly) return [];

    let family;
    if (/\bkids?\b|mother.and.daughter|father.and.son|mommy.and.me/.test(text)) family = 'kids';
    else if (/bonnet|turban/.test(text) && !/durag|wave cap|wave brush/.test(text)) family = 'bonnet';
    else if (/durag|wave cap|wave brush/.test(text)) family = 'velvet';
    else return [];

    const available = OFFERS[family].filter(candidate => !hasHandle(cart, candidate.handle));
    const differentColours = available.filter(candidate => !new RegExp('\\b' + candidate.color + '\\b', 'i').test(text));
    return [...differentColours, ...available.filter(candidate => !differentColours.includes(candidate))];
  };

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (e) {
      return (currency || 'USD') + ' ' + (Number(cents || 0) / 100).toFixed(2);
    }
  };

  const clear = () => mounts().forEach(el => { el.innerHTML = ''; el.hidden = true; });

  const fetchProduct = async (handle) => {
    const res = await fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('Product not available');
    return res.json();
  };

  const renderOffer = async (cart) => {
    const token = ++renderToken;
    const candidates = chooseCandidates(cart);
    if (!candidates.length) { clear(); return; }

    for (const offer of candidates) {
      try {
        const product = await fetchProduct(offer.handle);
        if (token !== renderToken) return;
        const variant = (product.variants || []).find(v => v.available === true);
        if (!variant || product.available === false) continue;

        const image = product.featured_image || (product.images && product.images[0]) || '';
        const productUrl = product.url || (rootPath + 'products/' + offer.handle);
        const html = `
          <div class="tb-cart-funnel__inner">
            <div class="tb-cart-funnel__heading">
              <span>Pairs well with your cart</span>
              <small>${escapeHtml(offer.label)}</small>
            </div>
            <div class="tb-cart-funnel__product">
              ${image ? '<a class="tb-cart-funnel__image" href="' + escapeHtml(productUrl) + '"><img src="' + escapeHtml(image) + '" alt="" loading="lazy"></a>' : ''}
              <div class="tb-cart-funnel__info">
                <a href="${escapeHtml(productUrl)}" class="tb-cart-funnel__title">${escapeHtml(product.title)}</a>
                <span class="tb-cart-funnel__price">${money(variant.price, cart.currency)}</span>
              </div>
              <button type="button" class="btn btn--small tb-cart-funnel__add" data-tb-cart-add="${variant.id}">Add</button>
            </div>
          </div>`;

        mounts().forEach(el => { el.hidden = false; el.innerHTML = html; });
        return;
      } catch (e) { /* Try the next in-stock colour if a product is unavailable. */ }
    }
    if (token === renderToken) clear();
  };

  const getCart = async () => {
    const res = await fetch(rootPath + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Unable to load cart');
    return res.json();
  };

  const refresh = async (cart) => {
    if (!mounts().length) return;
    try { await renderOffer(cart || await getCart()); }
    catch (e) { clear(); }
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-tb-cart-add]');
    if (!button) return;
    event.preventDefault();
    const variantId = Number(button.getAttribute('data-tb-cart-add'));
    if (!variantId) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const res = await fetch(rootPath + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      if (document.getElementById('CartPageForm')) { window.location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(() => refresh(), 350);
    } catch (e) {
      button.disabled = false;
      button.textContent = original;
    }
  });

  document.addEventListener('cart:updated', event => refresh(event.detail && event.detail.cart));
  document.addEventListener('ajaxProduct:added', () => setTimeout(() => refresh(), 250));
  document.addEventListener('page:loaded', () => refresh());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  } else {
    refresh();
  }
})();